(function () {
  'use strict';
 
  if (window.__stoqHighVariantFix) return;      // never install twice
  window.__stoqHighVariantFix = true;
 
  var TRIGGER   = '.stoq-bis-trigger-skeleton';
  var ID_INPUT  = 'form[action*="/cart/add"] input[name="id"]';
  // Assembled at runtime on purpose: if this file's source is ever echoed back
  // into the page (STOQ's js_config does exactly that), a literal here would
  // match our own copy instead of STOQ's assignment. Do not "simplify" this.
  var ANCHOR    = 'window._RestockRocketConfig.' + 'highVariantProduct';
  var POLL_MS   = 100;
  var GIVE_UP_MS = 20000;
  var SECTION   = 'bundle-option-data';   // theme-specific, see repairGroup()
  var FETCH_TIMEOUT = 2500;               // never block the modal longer than this
 
  function cfg() { return window._RestockRocketConfig; }
 
  function dbg() {
    if (window.console && console.debug) {
      console.debug.apply(console, ['[stoq-fix]'].concat([].slice.call(arguments)));
    }
  }
 
  function bundleUp() {
    return !!(window._Stoq && Object.keys(window._Stoq).length > 1);
  }
 
  // The theme's hidden input is the live source of truth for what the shopper
  // has selected; config.selected_variant_id is only the landing variant.
  function currentVariantId() {
    var el = document.querySelector(ID_INPUT);
    if (el && el.value) return Number(el.value);
    var c = cfg();
    return c && c.selected_variant_id ? Number(c.selected_variant_id) : null;
  }
 
  /* ---- 0. Availability repair via the theme's own data ------------------ */
  /* STOQ's availability for the 240 lazily-loaded variants is wrong (Bug 2), so
   * sold-out variants past #250 are filtered out of the modal's dropdown — they
   * only appear once you have physically selected them on the product page.
   *
   * Nothing Liquid-derived can fix this: product.variants, /products/x.js and
   * the theme's JSON-LD are ALL capped at 250, i.e. exactly the set STOQ already
   * gets right. But this theme ships a `bundle-option-data` section that returns
   * true availability for every value of the third option, given a City Grip +
   * Model selection — one request repairs the whole colour group. Verified:
   *   Black false / Kraft false / Slate Green true / Navy false / Tan false
   *
   * THEME-SPECIFIC. `section_id=bundle-option-data` belongs to this theme, not
   * to Shopify. If it is renamed or removed this fails open to the single-
   * variant heuristic below and behaviour is no worse than before.            */
 
  function currentOptionValues() {
    var q = new URLSearchParams(location.search).get('option_values');
    if (q) return q;
    var picker = document.querySelector('bundle-option-picker');
    if (!picker) return null;
    var ids = [].slice.call(picker.querySelectorAll('input:checked'))
      .map(function (i) { return i.getAttribute('data-option-value-id'); })
      .filter(Boolean);
    return ids.length ? ids.join(',') : null;
  }
 
  function repairGroup(c, selectedVariant) {
    // Fallback, used if the section fetch fails: the theme only renders its own
    // notify button when IT considers the current variant unavailable.
    function fallback() {
      if (selectedVariant && selectedVariant.available) {
        selectedVariant.available = false;
        c.selected_variant_available = false;
        dbg('fallback: corrected', selectedVariant.title);
      }
    }
 
    var ov = currentOptionValues();
    if (!ov) { fallback(); return Promise.resolve(); }
 
    var url = location.pathname + '?section_id=' + SECTION + '&option_values=' + encodeURIComponent(ov);
 
    var timeout = new Promise(function (resolve) { setTimeout(resolve, FETCH_TIMEOUT); });
    var work = fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc  = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('script[data-bundle-option-data]');
      if (!node) throw new Error('section payload missing');
      var data = JSON.parse(node.textContent);
 
      var byTitle = {};
      c.product.variants.forEach(function (v) { if (v.title) byTitle[v.title] = v; });
 
      var o1 = data.options[0].selectedValue;
      var o2 = data.options[1].selectedValue;
      var fixed = 0;
 
      data.options[2].values.forEach(function (val) {
        var v = byTitle[o1 + ' / ' + o2 + ' / ' + val.value];
        if (v && v.available && !val.available) { v.available = false; fixed++; }
      });
 
      // The selected variant is reported directly and authoritatively.
      if (data.selectedVariant) {
        var sv = c.product.variants.filter(function (x) {
          return Number(x.id) === Number(data.selectedVariant.id);
        })[0];
        if (sv) {
          sv.available = !!data.selectedVariant.available;
          c.selected_variant_available = sv.available;
        }
      }
      dbg('group repair: corrected', fixed, 'variant(s) in', o1 + ' / ' + o2);
    }).catch(function (e) {
      dbg('group repair failed, using fallback:', e);
      fallback();
    });
 
    return Promise.race([work, timeout]);
  }
 
  /* ---- 1. Click delegation — safe to attach at any point in the lifecycle */
 
  document.addEventListener('click', function (ev) {
    var trigger = ev.target && ev.target.closest ? ev.target.closest(TRIGGER) : null;
    if (!trigger) return;
 
    // Capture phase: runs before the legacy per-element listener, so the old
    // snippet cannot also fire openModal for the same click.
    ev.preventDefault();
    ev.stopImmediatePropagation();
 
    var vid = currentVariantId();
    if (!vid) { dbg('no variant id on the product form'); return; }
 
    var waited = 0;
 
    (function attempt() {
      var RR = window._RestockRocket;
      var c  = cfg();
 
      var ready = RR && typeof RR.openModal === 'function' && c && c.product;
      var v = ready
        ? c.product.variants.filter(function (x) { return Number(x.id) === vid; })[0]
        : null;
 
      // Two conditions, not one. On a deep link past #250 the variant does not
      // exist in product.variants until variant_data.json has landed, so waiting
      // on openModal alone opens the modal on the wrong variant, or on nothing.
      if (!ready || (!v && c && c.highVariantProduct && !c.remainingVariantsLoaded)) {
        if ((waited += 250) < GIVE_UP_MS) { setTimeout(attempt, 250); return; }
        dbg('timed out waiting for STOQ / variant data');
        return;
      }
 
      // Repair availability for the whole colour group, then open. See
      // repairGroup() — falls back to a single-variant fix if the theme section
      // is unavailable, and never blocks the modal for more than FETCH_TIMEOUT.
      repairGroup(c, v).then(function () { RR.openModal(null, vid); });
    })();
  }, true);
 
  /* ---- 2. Wait for STOQ's inline script, then recover the bootstrap ----- */
 
  var waitedForCfg = 0;
 
  (function waitForConfig() {
    var c  = cfg();
    var el = document.getElementById('RestockRocketConfig');
 
    // Not there yet — keep waiting rather than giving up, which is exactly what
    // v2 got wrong when injected early.
    if (!c || !c.product || !el || typeof c.selected_variant_id === 'undefined') {
      if ((waitedForCfg += POLL_MS) < GIVE_UP_MS) setTimeout(waitForConfig, POLL_MS);
      else dbg('config never appeared — doing nothing');
      return;
    }
 
    // Inline script completed normally: nothing to recover.
    if (Object.prototype.hasOwnProperty.call(c, 'selected_variant_available')) {
      dbg('page healthy, no recovery needed');
      return;
    }
 
    try {
      var src = el.textContent || '';
      // lastIndexOf, not indexOf: STOQ's real assignment is emitted at the end
      // of the snippet, while any echoed copy of this file sits early inside the
      // cachedSettings blob.
      var anchor = src.lastIndexOf(ANCHOR);
      if (anchor === -1) { dbg('anchor not found — snippet changed upstream'); return; }
 
      // Optimistic default so we never flash "Notify me" on a sellable variant.
      // Corrected per-variant at click time above.
      c.selected_variant_available = true;
 
      // NOTE: if you ever deploy to a shop whose CSP lacks 'unsafe-eval', swap
      // these two lines for an inline <script> element (copy .nonce from `el`):
      //   var s = document.createElement('script');
      //   if (el.nonce) s.nonce = el.nonce;
      //   s.textContent = src.slice(anchor);
      //   document.head.appendChild(s); s.remove();
      (0, eval)(src.slice(anchor));
 
      dbg('bootstrap recovered');
    } catch (e) {
      dbg('boot recovery failed:', e);
      return;
    }
 
    /* ---- 3. Bundle watchdog, timed from recovery (not from install) ----- */
    /* STOQ's createRestockRocketScript() appends the bundle with defer="defer".
     * Created this late in the page lifecycle that tag intermittently never
     * fetches at all — observed live: the <script> was in the DOM, connected,
     * with a correct src, and zero network activity for it. Appending the same
     * URL without defer loads it instantly. Harmless when it already worked.  */
 
    setTimeout(function () {
      try {
        if (bundleUp()) return;
        if (document.querySelector('script[data-stoq-fix-bundle]')) return;
 
        var conf = cfg();
        if (!conf) return;
 
        // Reuse whatever URL STOQ's own loader picked (full vs. bis build).
        var pending = document.querySelector('script[src*="restockrocket-"]');
        var url = pending ? pending.src : conf.scriptUrlProduct;
        if (!url) return;
 
        var s = document.createElement('script');
        s.src = url;
        s.setAttribute('data-stoq-fix-bundle', '1');
        document.body.appendChild(s);
        dbg('bundle watchdog fired');
      } catch (e) {
        dbg('watchdog skipped:', e);
      }
    }, 1500);
  })();
})();
